
import { RevButtonBase } from '@ds/components/ButtonBase'
import isEmpty from 'lodash/isEmpty'

import { trackClick } from '@tracking/events'

import { imageValidator } from '../../helpers/image'
import BlockTitle from '../private/BlockTitle'
import ImageRender from '../private/ImageRender'

// Displays a description text and a picture, and optionally a call to action
export default {
  components: {
    BlockTitle,
    ImageRender,
  },
  props: {
    link: {
      type: Object,
      default: null,
    },
    image: {
      type: Object,
      validator: imageValidator,
      default: () => ({}),
    },
    subtitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tracking: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getTag() {
      return isEmpty(this.link) ? 'div' : RevButtonBase
    },
    hasImage() {
      return !isEmpty(this.image)
    },
    getTarget() {
      return this.link?.targetBlank ? '_blank' : false
    },
  },
  methods: {
    sendTrackingData() {
      if (!isEmpty(this.link)) {
        trackClick({
          ...this.tracking,
          name: this.image?.alt,
        })
      }
    },
  },
}
